export const FETCH_LISTING = "FETCH_LISTING";
export const FETCH_LISTINGS = "FETCH_LISTINGS";